import React from 'react';
import { Router } from 'react-router-dom';
import { connect } from 'react-redux';
import Proptypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import styled, { injectGlobal } from 'styled-components';
import styledNormalize from 'styled-normalize';
import { history } from '../utils/history.ts';
import App from './App';

import { appActions } from './app.actions';
import { COLORS, FONT_FAMILY } from './common/constants/styles';
import ErrorPage from './common/components/ErrorPage.tsx';
import { DidomiModal } from '../details/didomi/DidomiModal';

const dictionaries = {};

dictionaries.en = require('../i18n/en.json');
dictionaries['en-UK'] = require('../i18n/en-UK.json');
dictionaries['de-DE'] = require('../i18n/de-DE.json');
dictionaries['es-ES'] = require('../i18n/es-ES.json');
dictionaries.ja = require('../i18n/ja.json');
dictionaries['uk-UA'] = require('../i18n/uk-UA.json');
dictionaries['zh-TW'] = require('../i18n/zh-TW.json');
dictionaries['zh-CN'] = require('../i18n/zh-CN.json');
dictionaries['zh-HK'] = require('../i18n/zh-HK.json');
dictionaries.th = require('../i18n/th.json');
dictionaries.id = require('../i18n/id.json');
dictionaries.ko = require('../i18n/ko.json');
dictionaries.vi = require('../i18n/vi.json');

injectGlobal`
    ${styledNormalize}
    ${FONT_FAMILY.multipleRegularCss};

    html {
        box-sizing: border-box;
    }
    *, *:before, *:after {
        box-sizing: inherit;
    }


    body {
        background-color: ${COLORS.ultralightGrey};
        margin: 0;
        padding: 0;
        font-weight: 400;
        text-rendering: geometricPrecision;
        line-height: 1.3;
    }

    img {
        max-width: 100%;
        height: auto;
    }
`;

const ErrorPageWrapper = styled.div`
    min-height: 100vh;
`;

const incomingPath = window.location.href.split('?')[0];
const destination = incomingPath.split('/').slice(-1)[0];

function mapStateToProps(state) {
    return {
        authenticating: state.authentication.loggingIn,
        member: state.member,
        loggedIn: state.app.memberLoggedIn,
        blockUI: state.notifications.blockUI,
        redirect: state.app.redirect,
        localeSet: state.app.locale,
        clientConfig: state.app.clientConfig,
        presentationConfig: state.app.presentationConfig,
        appConfig: state.app.appConfig,
        serverCrash: state.app.fiveHundred,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setAndSaveAppConfig: () => {
            dispatch(appActions.setAndSaveAppConfig());
        },
    };
}

class AppContainer extends React.Component {
    constructor(props) {
        super(props);

        this.toRegister = destination === 'register';
    }
    static propTypes = {
        lang: Proptypes.string,
        clientConfig: Proptypes.object,
        appConfig: Proptypes.object,
        loggedIn: Proptypes.bool,
        authenticating: Proptypes.bool,
    };
    componentDidMount() {
        this.props.setAndSaveAppConfig();
    }
    onLocaleChange(selectedItem) {
        const countries = [
            { name: 'Spain', lang: 'es-ES' },
            { name: 'United Kingdom', lang: 'en-UK' },
            { name: 'Germany', lang: 'de-DE' },
        ];

        countries.forEach((item) => {
            if (item.name === selectedItem) {
                this.props.dispatch(appActions.setAndSaveLocale(item.lang));
            }
        });
    }

    render() {
        const { localeSet, appConfig } = this.props;
        const appConfigEmpty = !appConfig || Object.keys(appConfig).length === 0;

        return appConfigEmpty ? null : (
            <>
                <IntlProvider locale={localeSet} messages={dictionaries[localeSet]}>
                    <Router history={history} basename={process.env.PUBLIC_URL}>
                        {this.props.serverCrash ? (
                            <ErrorPageWrapper>
                                <ErrorPage
                                    type="redirect"
                                    locale={this.props.clientConfig}
                                    contentId="p500"
                                />
                            </ErrorPageWrapper>
                        ) : (
                            <App query {...this.props} />
                        )}
                    </Router>
                    {appConfig.DIDOMI_ENABLED && <DidomiModal />}
                </IntlProvider>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
